import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M3.001 2.079V18.5c0 .276.223.5.501.5.276 0 .499-.224.499-.5l.001-8.06c2.314-.807 4.665-.324 6.941.158 1.356.287 2.671.565 3.933.565.971 0 1.913-.168 2.816-.622 0 0 .145-.078.228-.196s.082-.266.082-.266v-8s0-.282-.215-.425-.514-.02-.514-.02c-1.77.906-3.884.459-6.123-.015-2.407-.511-5.137-1.088-7.835-.004 0 0-.139.048-.226.18s-.087.284-.087.284z',
  ],
  height: 20,
  width: 20,
});
